import { render, staticRenderFns } from "./ahAuthorityTable.vue?vue&type=template&id=39faa5ab&"
import script from "./ahAuthorityTable.vue?vue&type=script&lang=js&"
export * from "./ahAuthorityTable.vue?vue&type=script&lang=js&"
import style0 from "./ahAuthorityTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports